import { Injectable, ElementRef } from '@angular/core';
import { ColumnDefinition } from '../models/colDef.model'
import * as XLSX from 'xlsx';
import { I } from '@angular/cdk/keycodes';
import { UtilsService } from './Utils.service';
const EXCEL_EXTENSION = '.xlsx';
const ALFABETO_AUX = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
@Injectable()
export class ExportService {
    
    public ExportDataSourceToExcel(colDefs: ColumnDefinition[], data: Array<any>, fileName: string)
    {
        let colHeaders = colDefs.filter(c => c.visible);
        let wsCols = colHeaders.map(c => { return {wpx: parseInt(c.width.replace('px',''))} })
        let dataToExport = [];
        data.forEach(d => {
            let dataCols = {};
            colHeaders.forEach(c => dataCols[c.header] = d[c.columnDef])
            dataToExport.push(dataCols);
        });
        const ws: XLSX.WorkSheet=XLSX.utils.json_to_sheet(dataToExport);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        ws['!cols'] = wsCols;
        XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');

        XLSX.writeFile(wb, fileName + '.xlsx');

    }
    public ExportDataExcel(data: Array<any>, fileName: string)
    {
        let dataToExport = [];
        let wsCols = [];

        data.forEach(d => {
            let dataCols = {};
            let index = 0;
            for(const val in d){
                dataCols[val] = d[val];
                wsCols.push({wpx:170})
                index++;
            }
            dataToExport.push(dataCols);
        });
        const ws: XLSX.WorkSheet=XLSX.utils.json_to_sheet(dataToExport);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        ws['!cols'] = wsCols;
        XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');

        XLSX.writeFile(wb, fileName + '.xlsx');

    }

    public ExportViewReport(elementRef : ElementRef,params : any){
        elementRef.nativeElement.contentWindow.postMessage(JSON.stringify(params),'*');
    }

    /**
     * 2021-10-13 (aaangeles)
     */
    public ExportDataSourceToExcel2(colDefs: ColumnDefinition[], data: Array<any>, fileName: string) {
        let colHeaders = colDefs.filter(c => c.visible);
        let wsCols = colHeaders.map(c => { return { wpx: parseInt(c.width.replace('px', '')) } })
        let dataToExport = [];
        data.forEach(d => {
            let dataCols = {};
            // 2021-10-13 (aaangeles) INICA CONVERSION
            colHeaders.forEach(c => {
                if (c.header !== "") {
                    switch (c.cellTemplate) {
                        case 'number': dataCols[c.header] = this.Decimales(c, d[c.columnDef]); break;
                        case 'money': dataCols[c.header] = this.ToMoney(d[c.columnDef]); break;
                        default: dataCols[c.header] = d[c.columnDef]; break;
                    }
                }
            });
            // 2021-10-13 (aaangeles) TERMINA
            dataToExport.push(dataCols);
        });
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        ws['!cols'] = wsCols;
        XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');
        XLSX.writeFile(wb, fileName + '.xlsx');
    }
    public ToMoney(_cant: any) {
        return "$ " + _cant.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }
    public Decimales(c: any, _cant: any) {
        let result = '0';
        let decimales = []
        decimales = c['digitInfo'] ? c['digitInfo'].split('.') : [];
        if (decimales.length == 2) {
            result = _cant.toFixed(decimales[1]).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        } else {
            result = _cant.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            result = result.slice(-result.length, -2)
        }
        return result;
    }

    public _cuentaDecimales(c: any) {
        let result = '0';
        let decimales = []
        decimales = c['digitInfo'] ? c['digitInfo'].split('.') : [];
        if (decimales.length == 2) {
            result = "#,##0.00"
        } else {
            result = "#,##0"; // 2021-11-25 (aaangeles) correccion para que tome el valor numerico en el excel
        }
        return result;
    }
    // 2021-11-03 (aaangeles)
    private _createDate( def:any, value:string ) {       
        let FechaSplit : any[] = value.split('/');
        let _fecha : Date = new Date();
        let fechaTempISO : any;
        if(def.horas) { // Verifica que sea un valor con horas
            let anio        = FechaSplit[2].split(' '); // Corta el año de las horas
            let _time       : any[] = anio[1].split(':'); // Corta las horas y minutos
            _fecha          = new Date(Number(anio[0]),Number(FechaSplit[1])-1,Number(FechaSplit[0]),_time[0],_time[1],59)
        } else {
            fechaTempISO    = new Date(Number(FechaSplit[2]),Number(FechaSplit[1])-1,Number(FechaSplit[0])).toISOString().slice(0,19); // toma las horas de la zona horaria
            _fecha          = new Date(fechaTempISO);
        }
        return _fecha;
    }

    // 2021-10-22 (aaangeles) INICA CONVERSION
    public ExportDataSourceToExcelCustom(colDefs: any[], data: Array<any>, fileName: string) {
        let wsCols = colDefs.map(c => { return {wpx: parseInt(c.width.replace('px',''))} });
        const worksheet: XLSX.WorkSheet = this._createNewWorkSheet(data,colDefs);
        worksheet['!cols'] = wsCols;
        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Hoja1');
        XLSX.writeFile(workbook, fileName + EXCEL_EXTENSION );
    }
    public _addColumns( _c : number) : any[] {
        let ds : any[] = ALFABETO_AUX.split("");
        let _AuxLetras : any[] = ALFABETO_AUX.split("") ;
        if( ds.length < _c ) _AuxLetras.forEach( letra => { if( ds.length <= _c ) {  _AuxLetras.forEach( subLetra => {  if( ds.length <= _c ) ds.push( letra + subLetra ) } ) } });
        return ds;
    }
    public _createNewWorkSheet(_ds: Array<any>, _cabeceras: any[]): XLSX.WorkSheet {
        let _ws: XLSX.WorkSheet = {};
        let _letra_columna: any[] = this._addColumns(_cabeceras.length);
        let _Registrofinal: string = _letra_columna[_cabeceras.length - 1] + (_ds.length + 1).toString();
        let _posicionColumn: number = 0;
        _ws['!ref'] = "A1:" + _Registrofinal;
        _cabeceras.forEach((c) => {
            let C = _letra_columna[_posicionColumn]; // Columna
            let contRow: number = 0; //posicion de registro
            let R = (contRow + 1).toString(); // Consecutivco Renglón cabecera
            if (_ds.length == 0) { // Si no se tienen registros ingresa solo las cabeceras.
                _ws[C + R] = { t: "t", v: c.header };
            } else {
                _ws[C + R] = { t: "t", v: c.header }; // Renglon de cabecara de columna actual
                contRow++;  // incrementa contador para renglon de datos
                _ds.forEach((d) => { // recorre listado para ingresar datos de acuero a la columna actual
                    let _tipo = "t";
                    let _formato = "";
                    let _value: any;
                    switch (c.cellTemplate) {
                        case "fecha":
                        case "date":
                            var us = new UtilsService();
                            _tipo = d[c.columnDef] ? "d" : 't';
                            _value = d[c.columnDef] ? new Date(new Date(d[c.columnDef]).getTime() + us['timezoneoffset']) : '';
                            _formato = d[c.columnDef] ? "dd/mm/yyyy" : '';
                            break;
                        case "dateDBFormat":
                            _tipo = d[c.columnDef] ? "d" : 't';
                            _value = d[c.columnDef] ? this._createDate(c,d[c.columnDef]) : '';
                            _formato = d[c.columnDef] ? ( c['horas'] ? 'dd/mm/yyyy hh:mm' : "dd/mm/yyyy" ) : '';
                            break;
                        case "number":
                            _tipo = "n";
                            _value = d[c.columnDef] || 0;
                            _formato = this._cuentaDecimales(c);
                            break;
                        case "money":
                            _tipo = "n";
                            _value = d[c.columnDef] || 0;
                            _formato = "[$$-es-MX] * #,##0.00;-[$$-es-MX] * #,##0.00;";
                            break;
                        default:
                            _tipo = "t";
                            _value = d[c.columnDef] || '';
                            break;
                    }
                    R = (contRow + 1).toString(); // consecutivo siguiente para el row de datos
                    _ws[C + R] = _formato ? { t: _tipo, v: _value, z: _formato, } : { t: _tipo, v: _value }; // agrega Datos del renglon de columna actual
                    contRow++; // incrementa el renglon de datos
                });
            }
            _posicionColumn++; // incrementa poscion de la columna actual
        });
        return _ws;
    }
}